export const BUILD_VERSION: string | null = '1793800368345';
